export default __webpack_public_path__ + "static/media/blackjoker.fac0985c.png";